/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Text } from '~components/Typography';

type TablePaginationProps = unknown;

const TablePagination = (props: TablePaginationProps): React.ReactElement => {
  return <Text>Table Component is not available for Native mobile apps.</Text>;
};

export { TablePagination };
